import * as SeparatorPrimitive from '@radix-ui/react-separator'
import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'
import { cn } from '../../lib/utils'

const separatorVariants = cva('shrink-0', {
  variants: {
    variant: {
      default: 'bg-border',
      'border-glass': '',
      'border-glass-strong': '',
    },
    orientation: {
      horizontal: 'h-[1px] w-full',
      vertical: 'h-full w-[1px]',
    },
  },
  compoundVariants: [
    {
      variant: 'border-glass',
      orientation: 'horizontal',
      class: 'select-border-glass-soft',
    },
    {
      variant: 'border-glass',
      orientation: 'vertical',
      class: 'select-border-glass-vertical-soft',
    },
    {
      variant: 'border-glass-strong',
      orientation: 'horizontal',
      class: 'select-border-glass-strong',
    },
    {
      variant: 'border-glass-strong',
      orientation: 'vertical',
      class: 'select-border-glass-vertical-strong',
    },
  ],
  defaultVariants: { variant: 'default', orientation: 'horizontal' },
})

const Separator = React.forwardRef<
  React.ElementRef<typeof SeparatorPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root> & VariantProps<typeof separatorVariants>
>(({ className, orientation = 'horizontal', decorative = true, variant, ...props }, ref) => (
  <div className="flex flex-row self-stretch">
    <SeparatorPrimitive.Root
      ref={ref}
      decorative={decorative}
      orientation={orientation}
      className={cn(separatorVariants({ variant, orientation }), className)}
      {...props}
    />
  </div>
))
Separator.displayName = SeparatorPrimitive.Root.displayName

export { Separator }
